import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import SelectFild from '../../components/SelectFild/SelectFild';
import DateFild from '../../components/DateTimePicker/DateFild';
import { useFormik } from 'formik';
import { postProjectSave } from '../../apiservices/ApiServices';
import Modals from '../../components/Modals/Modals';

const emptyProject = {
    productCategory: '',
    productSubCategory: '',
    productId: '',
    regulatoryStandard: '',
    proStartDate: '',
    proEndDate: '',
    empCount: '',
    amounts: '',
};

const mapEditDataToFormValues = (editData) => {
    const setting = editData?.product_invoice_setting;
    if (!setting) {
        return {
            invoiceLevel: 'project',
            currencyCode: '',
            netProfessionalFees: '',
            outPocketExpenses: '',
            projects: [{ ...emptyProject }],
        };
    }

    const projects = (setting.products || []).map((prod) => ({
        productCategory: prod.category_id?.toString() || '',
        productSubCategory: prod.sub_category_id?.toString() || '',
        productId: prod.product_id?.toString() || '',
        regulatoryStandard: prod.accounts_standard_id?.toString() || '',
        proStartDate: prod.start_date || '',
        proEndDate: prod.end_date || '',
        empCount: prod.employee_count?.toString() || '',
        amounts: '', // will be filled from cost_breakup
    }));

    // Populate amounts from cost_breakup based on invoice level
    const costBreakup = setting.cost_breakup || [];
    if (costBreakup.length > 0) {
        const invoiceLevel = setting.invoice_level;
        projects.forEach(project => {
            let matchId = null;
            if (invoiceLevel === 'product') {
                matchId = project.productId;
            } else if (invoiceLevel === 'category') {
                matchId = project.productCategory;
            } else if (invoiceLevel === 'sub_category') {
                matchId = project.productSubCategory;
            }
            if (matchId) {
                const matched = costBreakup.find(item => String(item.id) === String(matchId));
                if (matched && matched.amount !== undefined) {
                    project.amounts = String(matched.amount);
                }
            }
        });
    }

    return {
        invoiceLevel: setting.invoice_level || 'project',
        currencyCode: setting.currency_code || '',
        amount: setting.net_professional_fees || '',  // not directly from cost_breakup
        netProfessionalFees: setting.net_professional_fees || '',
        outPocketExpenses: setting.out_of_pocket_expenses || '',
        projects: projects.length ? projects : [{ ...emptyProject }],
    };
};

const StepTwo = (props) => {
    const [viewSummaryModal, setViewSummaryModal] = useState(false);
    const formik = useFormik({
        initialValues: mapEditDataToFormValues(props.editData),
        enableReinitialize: true,
        onSubmit: async (values) => {
            props.setLoadings(true);
            let postData;

            if (values.invoiceLevel === 'project') {
                postData = {
                    project_id: props.ids,
                    step: 'product_invoice_setting',
                    data: {
                        invoice_level: values.invoiceLevel,
                        products: values.projects.map((item) => ({
                            product_id: item?.productId,
                            category_id: item?.productCategory,
                            sub_category_id: item?.productSubCategory,
                            start_date: item?.proStartDate,
                            end_date: item?.proEndDate,
                            accounts_standard_id: item?.regulatoryStandard,
                            employee_count: item?.empCount,
                        })),
                        currency_code: values.currencyCode,
                        net_professional_fees: values.netProfessionalFees,
                        out_of_pocket_expenses: values.outPocketExpenses,
                    },
                };
            }

            if (values.invoiceLevel === 'category') {
                postData = {
                    project_id: props.ids,
                    step: 'product_invoice_setting',
                    data: {
                        invoice_level: values.invoiceLevel,
                        products: values.projects.map((item) => ({
                            product_id: item?.productId,
                            category_id: item?.productCategory,
                            sub_category_id: item?.productSubCategory,
                            start_date: item?.proStartDate,
                            end_date: item?.proEndDate,
                            accounts_standard_id: item?.regulatoryStandard,
                            employee_count: item?.empCount,
                        })),
                        cost_breakup: values.projects.map((item) => ({
                            id: item?.productCategory,
                            amount: item?.amounts,
                        })),
                        currency_code: values.currencyCode,
                        net_professional_fees: values.netProfessionalFees,
                        out_of_pocket_expenses: values.outPocketExpenses,
                    },
                };
            }

            if (values.invoiceLevel === 'sub_category') {
                postData = {
                    project_id: props.ids,
                    step: 'product_invoice_setting',
                    data: {
                        invoice_level: values.invoiceLevel,
                        products: values.projects.map((item) => ({
                            product_id: item?.productId,
                            category_id: item?.productCategory,
                            sub_category_id: item?.productSubCategory,
                            start_date: item?.proStartDate,
                            end_date: item?.proEndDate,
                            accounts_standard_id: item?.regulatoryStandard,
                            employee_count: item?.empCount,
                        })),
                        cost_breakup: values.projects.map((item) => ({
                            id: item?.productSubCategory,
                            amount: item?.amounts,
                        })),
                        currency_code: values.currencyCode,
                        net_professional_fees: values.netProfessionalFees,
                        out_of_pocket_expenses: values.outPocketExpenses,
                    },
                };
            }

            if (values.invoiceLevel === 'product') {
                postData = {
                    project_id: props.ids,
                    step: 'product_invoice_setting',
                    data: {
                        invoice_level: values.invoiceLevel,
                        products: values.projects.map((item) => ({
                            product_id: item?.productId,
                            category_id: item?.productCategory,
                            sub_category_id: item?.productSubCategory,
                            start_date: item?.proStartDate,
                            end_date: item?.proEndDate,
                            accounts_standard_id: item?.regulatoryStandard,
                            employee_count: item?.empCount,
                        })),
                        cost_breakup: values.projects.map((item) => ({
                            id: item?.productId,
                            amount: item?.amounts,
                        })),
                        currency_code: values.currencyCode,
                        net_professional_fees: values.netProfessionalFees,
                        out_of_pocket_expenses: values.outPocketExpenses,
                    },
                };
            }

            try {
                const res = await postProjectSave(postData);
                props.Toast.success(res.data.message);
                let proid = res?.data?.data?.project_id;
                props.setIds(proid);
                props.postProductActivityLists(proid);
                props.setLoadings(false);
                props.setStep(3);
            } catch (error) {
                props.setLoadings(false);
                props.Toast.error(error.response?.data?.message || 'Error submitting data');
            }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const getFilteredSubCategories = (categoryId) => {
        if (!categoryId || !props.projectList?.sub_category_list) return [];
        return props.projectList.sub_category_list
            .filter((sub) => sub.parent_category_id === parseInt(categoryId))
            .map((sub) => ({ id: sub.category_id, name: sub.category_name }));
    };

    const getFilteredProducts = (subCategoryId) => {
        if (!subCategoryId || !props.projectList?.product_list) return [];
        return props.projectList.product_list
            .filter((prod) => prod.sub_category_id === parseInt(subCategoryId))
            .map((prod) => ({ id: prod.product_id, name: prod.product_name }));
    };

    const add = () => {
        setFieldValue('projects', [...values.projects, { ...emptyProject }]);
    };

    const remove = (index) => {
        const updated = values.projects.filter((_, i) => i !== index);
        setFieldValue('projects', updated);
    };

    useEffect(() => {
        if (values.projects && values.projects.length > 0) {
            const totalAmount = values.projects.reduce((sum, project) => {
                const amount = parseFloat(project.amounts) || 0;
                return sum + amount;
            }, 0);
            setFieldValue('netProfessionalFees', totalAmount.toString());
        } else {
            setFieldValue('netProfessionalFees', '0');
        }
    }, [values.projects, setFieldValue]);

    useEffect(() => {
        if (viewSummaryModal && values.projects && values.projects.length > 0) {
            const needsUpdate = values.projects.some(project =>
                project.amounts === '' || project.amounts === null || project.amounts === undefined
            );

            if (needsUpdate) {
                const updatedProjects = values.projects.map(project => ({
                    ...project,
                    amounts: ''
                }));
                setFieldValue('projects', updatedProjects);
                setFieldValue('netProfessionalFees', '0');
            }
        }
    }, [viewSummaryModal]);

    return (
        <>
            <form onSubmit={handleSubmit} autoComplete="off">
                <div className="fieldsets cols_5">
                    <div className="fieldsets-title">Invoice Level + Product</div>
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Invoice Level</label>
                                <ul className="radiolist">
                                    <li>
                                        <div className="radioBox">
                                            <input
                                                type="radio"
                                                name="invoiceLevel"
                                                value="project"
                                                checked={values.invoiceLevel === 'project'}
                                                onChange={handleChange}
                                            />
                                            <span className="rdoMark"></span>
                                            <label>Project Level</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="radioBox">
                                            <input
                                                type="radio"
                                                name="invoiceLevel"
                                                value="product"
                                                checked={values.invoiceLevel === 'product'}
                                                onChange={handleChange}
                                            />
                                            <span className="rdoMark"></span>
                                            <label>Product Name Level</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="radioBox">
                                            <input
                                                type="radio"
                                                name="invoiceLevel"
                                                value="category"
                                                checked={values.invoiceLevel === 'category'}
                                                onChange={handleChange}
                                            />
                                            <span className="rdoMark"></span>
                                            <label>Product Category Level</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="radioBox">
                                            <input
                                                type="radio"
                                                name="invoiceLevel"
                                                value="sub_category"
                                                checked={values.invoiceLevel === 'sub_category'}
                                                onChange={handleChange}
                                            />
                                            <span className="rdoMark"></span>
                                            <label>Product Sub Category Level</label>
                                        </div>
                                    </li>
                                </ul>
                                {errors.invoiceLevel && touched.invoiceLevel && (
                                    <p className="errormsg">{errors.invoiceLevel}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="fieldsets cols_7">
                                <div className="fieldsets-title">Products</div>
                                {values.projects.map((project, index) => (
                                    <div key={index} className="fieldsets cols_7 mainFS">
                                        <div className="fieldsetsboxs">
                                            <h6>Product {index + 1}</h6>
                                            <div className="addreovebtns">
                                                <button type="button" className="btn add-btn" onClick={add}>
                                                    +
                                                </button>
                                                {values.projects.length > 1 && (
                                                    <button
                                                        type="button"
                                                        className="btn remove-btn"
                                                        onClick={() => remove(index)}
                                                    >
                                                        -
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <div className="formsBox">
                                            <Row>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Product Category</label>
                                                        <SelectFild
                                                            Firstop="Select"
                                                            selectName={`projects[${index}].productCategory`}
                                                            options={(props.projectList?.category_list || []).map((cat) => ({
                                                                id: cat.category_id,
                                                                name: cat.category_name,
                                                            }))}
                                                            value={project.productCategory}
                                                            onChange={(selectedOption) => {
                                                                setFieldValue(`projects[${index}].productCategory`, selectedOption?.value || '');
                                                                // Reset dependent fields
                                                                setFieldValue(`projects[${index}].productSubCategory`, '');
                                                                setFieldValue(`projects[${index}].productId`, '');
                                                            }}
                                                            onBlur={() => handleBlur(`projects[${index}].productCategory`)}
                                                        />
                                                        {errors.projects?.[index]?.productCategory &&
                                                            touched.projects?.[index]?.productCategory && (
                                                                <p className="errormsg">{errors.projects[index].productCategory}</p>
                                                            )}
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Product Sub Category</label>
                                                        <SelectFild
                                                            Firstop="Select"
                                                            selectName={`projects[${index}].productSubCategory`}
                                                            options={getFilteredSubCategories(project.productCategory)}
                                                            value={project.productSubCategory}
                                                            onChange={(selectedOption) => {
                                                                setFieldValue(`projects[${index}].productSubCategory`, selectedOption?.value || '');
                                                                setFieldValue(`projects[${index}].productId`, '');
                                                            }}
                                                            onBlur={() => handleBlur(`projects[${index}].productSubCategory`)}
                                                        />
                                                        {errors.projects?.[index]?.productSubCategory &&
                                                            touched.projects?.[index]?.productSubCategory && (
                                                                <p className="errormsg">{errors.projects[index].productSubCategory}</p>
                                                            )}
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Select Product</label>
                                                        <SelectFild
                                                            Firstop="Select"
                                                            selectName={`projects[${index}].productId`}
                                                            options={getFilteredProducts(project.productSubCategory)}
                                                            value={project.productId}
                                                            onChange={(selectedOption) =>
                                                                setFieldValue(`projects[${index}].productId`, selectedOption?.value || '')
                                                            }
                                                            onBlur={() => handleBlur(`projects[${index}].productId`)}
                                                        />
                                                        {errors.projects?.[index]?.productId &&
                                                            touched.projects?.[index]?.productId && (
                                                                <p className="errormsg">{errors.projects[index].productId}</p>
                                                            )}
                                                    </div>
                                                </Col>
                                                <Col md={2}>
                                                    <div className="form-group">
                                                        <label className="form-label">Start Date</label>
                                                        <DateFild
                                                            value={project.proStartDate}
                                                            onChange={(date) => setFieldValue(`projects[${index}].proStartDate`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={2}>
                                                    <div className="form-group">
                                                        <label className="form-label">End Date</label>
                                                        <DateFild
                                                            value={project.proEndDate}
                                                            onChange={(date) => setFieldValue(`projects[${index}].proEndDate`, date)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Regulatory Applicable Standard</label>
                                                        <SelectFild
                                                            Firstop="Select"
                                                            selectName={`projects[${index}].regulatoryStandard`}
                                                            options={props.commonMaster?.accounting_standards}
                                                            value={project.regulatoryStandard}
                                                            onChange={(selectedOption) =>
                                                                setFieldValue(`projects[${index}].regulatoryStandard`, selectedOption?.value || '')
                                                            }
                                                            onBlur={() => handleBlur(`projects[${index}].regulatoryStandard`)}
                                                        />
                                                        {errors.projects?.[index]?.regulatoryStandard &&
                                                            touched.projects?.[index]?.regulatoryStandard && (
                                                                <p className="errormsg">{errors.projects[index].regulatoryStandard}</p>
                                                            )}
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="form-group">
                                                        <label className="form-label">Employee Count</label>
                                                        <input
                                                            type="text"
                                                            name={`projects[${index}].empCount`}
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={project.empCount}
                                                            onChange={(e) => setFieldValue(`projects[${index}].empCount`, e.target.value)}
                                                        />
                                                        {errors.projects?.[index]?.empCount &&
                                                            touched.projects?.[index]?.empCount && (
                                                                <p className="errormsg">{errors.projects[index].empCount}</p>
                                                            )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Currency Code</label>
                                <SelectFild
                                    Firstop="Select Currency Code"
                                    selectName="currencyCode"
                                    options={props.commonMaster?.currency}
                                    value={values.currencyCode}
                                    onChange={(selectedOption) => setFieldValue('currencyCode', selectedOption?.value || '')}
                                    onBlur={handleBlur}
                                />
                                {errors.currencyCode && touched.currencyCode && (
                                    <p className="errormsg">{errors.currencyCode}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Net Professional Fees</label>
                                <input
                                    type="text"
                                    name="netProfessionalFees"
                                    className="form-control"
                                    value={values.netProfessionalFees}
                                    readOnly
                                    disabled
                                    style={{ backgroundColor: '#f5f5f5' }}
                                />
                                {errors.netProfessionalFees && touched.netProfessionalFees && <p className="errormsg">{errors.netProfessionalFees}</p>}
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Out of Pocket Expenses</label>
                                <input
                                    type="text"
                                    id="outPocketExpenses"
                                    name="outPocketExpenses"
                                    className="form-control"
                                    autoComplete="off"
                                    value={values.outPocketExpenses}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.outPocketExpenses && touched.outPocketExpenses && (
                                    <p className="errormsg">{errors.outPocketExpenses}</p>
                                )}
                            </div>
                        </Col>
                        {values.invoiceLevel && values.invoiceLevel !== '' && (
                            <Col md={3}>
                                <div className="form-group" style={{ textAlign: 'center', marginTop: 15 }}>
                                    <button type="button" className="btn btn-primary" onClick={() => setViewSummaryModal(true)}>
                                        Cost Breakup Info
                                    </button>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className="button-boxs grid">
                        <button type="submit" className="btn btn-primary">
                            Save
                        </button>
                    </div>
                </div>
            </form>

            <Modals
                show={viewSummaryModal}
                handleClose={() => setViewSummaryModal(false)}
                title="Cost Breakup Info"
                textColor="#000"
                size="lg"
                centered={true}
                backdrop={true}
                onConfirm={() => setViewSummaryModal(false)}
            >
                <div className="invoiceData">
                    <table className="table table-bordered text-nowrap mb-0">
                        {values.invoiceLevel === 'project' && (
                            <tbody>
                                <tr>
                                    <th className="invoiceDataTH">Project Level</th>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        <div className="d-flex align-items-center">
                                            <label style={{ marginRight: 10 }}>Amount</label>
                                            <input
                                                type="text"
                                                name="amount"
                                                className="form-control"
                                                autoComplete="off"
                                                value={values.amount}
                                                onChange={(e) => setFieldValue('amount', e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        )}

                        {values.invoiceLevel === 'product' && (
                            <tbody>
                                {values.projects.map((project, idx) => {
                                    const matchedProduct = props.projectList?.product_list.find(
                                        (p) => p.product_id == project.productId
                                    );
                                    const productName = matchedProduct?.product_name || 'Unknown Product';
                                    return (
                                        <tr key={idx}>
                                            <th className="invoiceDataTH">{productName}</th>
                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="d-flex align-items-center">
                                                    <label style={{ marginRight: 10 }}>Amount</label>
                                                    <input
                                                        type="text"
                                                        name={`projects[${idx}].amounts`}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={project.amounts}
                                                        onChange={(e) => setFieldValue(`projects[${idx}].amounts`, e.target.value)}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        )}

                        {values.invoiceLevel === 'category' && (
                            <tbody>
                                {values.projects
                                    .filter(
                                        (project, idx, self) =>
                                            idx === self.findIndex((p) => p.productCategory === project.productCategory)
                                    )
                                    .map((project, idx) => {
                                        const matchedCategory = props.projectList?.category_list.find(
                                            (p) => p.category_id == project.productCategory
                                        );
                                        const categoryName = matchedCategory?.category_name || 'Unknown Category';
                                        return (
                                            <tr key={idx}>
                                                <th className="invoiceDataTH">{categoryName}</th>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <div className="d-flex align-items-center">
                                                        <label style={{ marginRight: 10 }}>Amount</label>
                                                        <input
                                                            type="text"
                                                            name={`projects[${idx}].amounts`}
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={project.amounts}
                                                            onChange={(e) => setFieldValue(`projects[${idx}].amounts`, e.target.value)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        )}

                        {values.invoiceLevel === 'sub_category' && (
                            <tbody>
                                {values.projects
                                    .filter(
                                        (project, idx, self) =>
                                            idx === self.findIndex((p) => p.productSubCategory === project.productSubCategory)
                                    )
                                    .map((project, idx) => {
                                        const matchedSubCategory = props.projectList?.sub_category_list.find(
                                            (p) => p.category_id == project.productSubCategory
                                        );
                                        const subCategoryName = matchedSubCategory?.category_name || 'Unknown Sub Category';
                                        return (
                                            <tr key={idx}>
                                                <th className="invoiceDataTH">{subCategoryName}</th>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <div className="d-flex align-items-center">
                                                        <label style={{ marginRight: 10 }}>Amount</label>
                                                        <input
                                                            type="text"
                                                            name={`projects[${idx}].amounts`}
                                                            className="form-control"
                                                            autoComplete="off"
                                                            value={project.amounts}
                                                            onChange={(e) => setFieldValue(`projects[${idx}].amounts`, e.target.value)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        )}
                    </table>
                </div>
                <div className="modalfooters">
                    <div className="button-boxs grid">
                        <button onClick={() => setViewSummaryModal(false)} type="button" className="btn btn-primary">
                            Save
                        </button>
                        <button onClick={() => setViewSummaryModal(false)} type="button" className="btn btn-default">
                            Cancel
                        </button>
                    </div>
                </div>
            </Modals>
        </>
    );
};

export default StepTwo;